import React from "react";
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import {
  isCoach,
  isTournamentCoach,
} from '@projectK/context/RolesProvider';
import CoachDashboard from "./CoachDashboard";
import HeadCoachDashboard from "./HeadCoachDashboard";

const Dashboard = () => {

    const { user } = useAuthUser();

  if (isCoach(user)) {
    return <CoachDashboard />;
  } else if (isTournamentCoach(user)) {
    return <HeadCoachDashboard />;
  } else {
    return;
  }

};

export default Dashboard;
